import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getTenantUsers } from '@pingum/app-state-management/tenant/actions';
import { updateDashboardSubscriptions } from '@pingum/app-state-management/dashboard/actions';
import { updateEventTemplateSubscriptions } from '@pingum/app-state-management/eventTemplate/actions';
import { getUserSubscription } from '@pingum/app-state-management/userSubscription/actions';
import { getEventTypes } from '@pingum/app-state-management/eventType/actions';
import Page from '../../widgets/Page';
import OrganizationDashboardSubscriptionsCard from './OrganizationDashboardSubscriptionsCard';
import OrganizationEventTemplateSubscriptionsCard from './OrganizationEventTemplateSubscriptionsCard';
import { getTenantFromUrl } from '../../../utils/urlHelper';

export class OrganizationSubscriptionsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tenantName: getTenantFromUrl(),
      selectedTab: 0,
    };

    this.props.getTenantUsers(this.state.tenantName);
    this.props.getEventTypes();
  }

  handleChangeTab = (event, value) => {
    this.setState({ selectedTab: value });
  }

  render() {
    return (
      this.props.isOnboardingPage
        ? (
          <OrganizationEventTemplateSubscriptionsCard
            updateEventTemplateSubscriptions={this.props.updateEventTemplateSubscriptions}
            getUserSubscription={this.props.getUserSubscription}
          />
        )
        : (
          <Page
            title="Subscriptions"
            toolbar={
            !this.props.isOnboardingPage
            && (
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleChangeTab}
                indicatorColor="secondary"
                textColor="inherit"
              >
                <Tab label="Dashboards" />
                <Tab label="Workflows" />
              </Tabs>
            )
        }
            disableToolbarGutters
          >

            {
          this.state.selectedTab === 0
            && (
              <OrganizationDashboardSubscriptionsCard
                updateDashboardSubscriptions={this.props.updateDashboardSubscriptions}
                getUserSubscription={this.props.getUserSubscription}
              />
            )
        }
            {
            this.state.selectedTab === 1
            && (
              <OrganizationEventTemplateSubscriptionsCard
                updateEventTemplateSubscriptions={this.props.updateEventTemplateSubscriptions}
                getUserSubscription={this.props.getUserSubscription}
              />
            )
        }
          </Page>
        )
    );
  }
}

OrganizationSubscriptionsComponent.propTypes = {
  getTenantUsers: PropTypes.func,
  updateDashboardSubscriptions: PropTypes.func,
  updateEventTemplateSubscriptions: PropTypes.func,
  getUserSubscription: PropTypes.func,
  getEventTypes: PropTypes.func,
  isOnboardingPage: PropTypes.bool,
};

OrganizationSubscriptionsComponent.defaultProps = {
  getTenantUsers: () => {},
  updateDashboardSubscriptions: () => {},
  updateEventTemplateSubscriptions: () => {},
  getUserSubscription: () => {},
  getEventTypes: () => {},
  isOnboardingPage: false,
};

export const mapDispatchToProps = (dispatch) => ({
  getTenantUsers: (tenantName) => dispatch(getTenantUsers(tenantName)),
  updateDashboardSubscriptions:
    (auth0UserId, request, successMessage) => dispatch(
      updateDashboardSubscriptions(auth0UserId, request, successMessage),
    ),
  updateEventTemplateSubscriptions:
    (auth0UserId, request, successMessage) => dispatch(
      updateEventTemplateSubscriptions(auth0UserId, request, successMessage),
    ),
  getUserSubscription: (auth0userId, email) => dispatch(getUserSubscription(auth0userId, email)),
  getEventTypes: () => dispatch(getEventTypes()),
});

export default connect(
  null,
  mapDispatchToProps,
)(OrganizationSubscriptionsComponent);
